export const CartErrorMessages = {
    INVALID_ITEM_MSG : "Oops! One or more item(s) in your cart is out of stock.",
    INVALID_STORE_MSG : "Oops! Something went wrong. Please try again with different location."
}